import redesignedTheme from '../../../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css.div`
    
  .card {
    flex: 0 0 auto;
    display: flex;
    width: 720px;
    margin-bottom: 24px;
  }
  
  .top-stories .card {
    border-bottom: 7px solid ${redesignedTheme.colors.mist};
  }

  .card-description {
    margin-bottom: 24px;
  }
  
  .card-content {
    display: flex;
    flex-direction: column;
  }
  
  .top {
    order: -1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: 5px;
    padding-bottom: 13px;
  }
  
  .card-title {
    margin-top: 14px;
    margin-bottom: 4px;
    font-size: 30px;
    line-height: 130%;
  }
  
  .image-hd {
    width: 720px;
    margin: 0;
  }
  
  .meatball-icon {
    padding: 0;
  }
  
  .play-icon {
    margin-bottom: 2px;
  }  
`
